import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getProjectValidationOptions,
  useValidateProject,
} from '@/module/Author/Project/Validation/model/ProjectValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  projectId: Id;
  variant?: ValidationVariant;
}

export function ProjectValidationAction({ projectId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getProjectValidationOptions(projectId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateProject(projectId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
